import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, MemorialAdesao } from 'eddydata-lib';

@Injectable({
    providedIn: 'root'
})
export class MemorialAdesaoService extends BaseResourceService<MemorialAdesao> {

    constructor(
        protected injector: Injector
    ) {
        super(`memorial-adesao`, injector);
    }

}
